module.exports = __webpack_public_path__ + "img/signal_cellular_2_bar.3cf59188.svg";